module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "edit-container",
    attrs: {
      "id": "edit-game-vitals"
    }
  }, [(_vm.isSaving) ? _c('div', {
    staticClass: "companion-content-subsection"
  }, [_c('saver-large')], 1) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('div', {
    staticClass: "companion-content-subsection vitals"
  }, [_c('div', {
    staticClass: "edit-alias"
  }, [_c('h1', [_vm._v("Game Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localAlias),
      expression: "localAlias"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Game Title"
    },
    domProps: {
      "value": (_vm.localAlias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localAlias = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Note: Changing your game's title will change the URL to this page")])]), _vm._v(" "), _c('div', {
    staticClass: "edit-avatar"
  }, [_c('h1', [_vm._v("Avatar Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "avatar",
      "accept": "image/jpeg, image/png"
    },
    on: {
      "change": _vm.updateuploadedAvatarName
    }
  }), _vm._v(" "), (_vm.uploadedImageSrc) ? _c('div', {
    staticClass: "avatar-preview",
    style: (("background-image: url('" + _vm.uploadedImageSrc + "')"))
  }) : _vm._e(), _vm._v(" "), (_vm.avatarTooBig) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v("Maximum filesize for an Avatar is 10Mb")]) : _vm._e(), _vm._v(" "), (_vm.localAlias.trim() === '') ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v("Set a Title for this Game")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.isValidated()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitChanges($event)
      }
    }
  }, [_vm._v("Save")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-127175ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/Widgets/EditGameVitals.vue
// module id = 825
// module chunks = 2